import axios from "axios";

export default {
  name: "umpd",
  state: {
    listUmpd: [],
    umDetil: [],
  },
  getters: {
    getLapListUM: (state) => {
      return state.listUmpd;
    },
    getDetilUm: (state) => {
      return state.umDetil;
    },
  },
  mutations: {
    setLapListUM: (state, payload) => {
      state.listUmpd = payload;
    },
    setDetilUm: (state, payload) => {
      state.umDetil = payload;
    },
  },
  actions: {
    getUmpdById(store, { auth, id }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_SERVICEURL + "um_pd/um_pd_Detil_v2",
          params: {
            id_um_pd: id,
          },
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
          },
        })
          .then(({ data, status }) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getListSppd(store, { data }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_SERVICEURL + "sppds/no_sppds",
          params: {
            tlc: data.username,
          },
          auth: {
            username: data.username,
            password: data.password,
          },
          headers: {
            "X-API-KEY": data.apikey,
          },
        })
          .then(({ data, status }) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getItemDetailSppd(store, { data, id_sppd }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_SERVICEURL + "sppds/nama_item",
          params: {
            id_sppd: id_sppd,
          },
          auth: {
            username: data.username,
            password: data.password,
          },
          headers: {
            "X-API-KEY": data.apikey,
          },
        })
          .then(({ data, status }) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getLapDetilUM(store, { auth, id }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_SERVICEURL + "lap_um_pd/um_detil",
          params: {
            id_um: id,
          },
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
          },
        })
          .then(({ data, status }) => {
            store.commit("setDetilUm", data);
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getLapReviseDetilUM(store, { auth, id }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url:
            process.env.VUE_APP_SERVICEURL +
            "lap_um_pd/revisi_detil_pemakaian_update",
          params: {
            id_dtl_lk: id,
          },
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
          },
        })
          .then(({ data, status }) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    addLapDetilUm(store, { auth, data, url }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "post",
          url: process.env.VUE_APP_SERVICEURL + url,
          data: data,
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
          },
        })
          .then(({ data, status }) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getDetilLapUm(store, { auth, params, url }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_SERVICEURL + url,
          params: {
            tlc: auth.username,
            id_lk: params.id_lk,
            mode: params.mode,
          },
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
          },
        })
          .then(({ data, status }) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getFetchLapUmpd(store, { auth }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_SERVICEURL + "lap_um_pd/no_umpd",
          params: {
            tlc: auth.username,
          },
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
          },
        })
          .then(({ data, status }) => {
            store.commit("setLapListUM", data.no_umpd);
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getLapUMDetil(store, { auth, params }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url:
            process.env.VUE_APP_SERVICEURL + "lap_um_pd/detil_pemakaian_update",
          params: {
            id_dtl_lk: params.id,
          },
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
          },
        })
          .then(({ data, status }) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    putLapDetil(store, { auth, params }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "post",
          url: process.env.VUE_APP_SERVICEURL + params.url,
          data: params.data,
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
          },
        })
          .then(({ data, status }) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    saveLapUmpd(store, { auth, condition }) {
      return new Promise((resolve, reject) => {
        axios({
          method: condition.method,
          url: process.env.VUE_APP_SERVICEURL + "lap_um_pd",
          data: condition.data,
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
          },
        })
          .then(({ data, status }) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    deleteLapDetil(store, { auth, params }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "delete",
          url: process.env.VUE_APP_SERVICEURL + params.url,
          processData: false,
          data: {
            id: params.id,
          },
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
          },
        })
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    savedraftparsial(store, { auth, condition }) {
      return new Promise((resolve, reject) => {
        axios({
          method: condition.method,
          url: process.env.VUE_APP_SERVICEURL + "lap_um_pd/draft_parsial",
          data: condition.data,
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
          },
        })
          .then(({ data, status }) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
